import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import { API_BASE_URL } from "views/api"

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

// Sections for this page
import ReactApexChart from 'react-apexcharts'

const useStyles = makeStyles(styles);

export const bar_series= (budgets_data_income, budgets_data_expense) => {return ([{
              name: 'कुल अनुमानित आय',
              data: budgets_data_income
            }, {
              name: 'कुल अनुमानित ब्यय',
              data: budgets_data_expense
            }]);}

export const bar_options= (administrative_units) => {return({
  chart: {
    type: 'bar',
    height: 350,
    fontFamily: 'nepali-font'
  },
  colors: ['#567', '#134c7a'],
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '55%',
      endingShape: 'rounded'
    },
  },
  dataLabels: {
    enabled: false
  },
  stroke: {
    show: true,
    width: 2,
    colors: ['transparent']
  },
  xaxis: {
    categories: administrative_units,
  },
  yaxis: {
    title: {
      text: 'रु. (करोड)'
    }
  },
  fill: {
    opacity: 1
  },
  tooltip: {
    y: {
      formatter: function (val) {
        return "रु. " + val + " करोड"
      }
    }
  }})
};

export const title_map = {
  bhaktapur_district : {
    name: 'जि स स भक्तपुर',
  },
  changunarayan : {
    name: 'चाँगुनारायण नगरपालिका',
  },
  bhaktapur : {
    name: 'भक्तपुर नगरपालिका',
  },
  madhyapur_thimi : {
    name: 'मध्यपुर थिमि नगरपालिका',
  },
  suryabinayak: {
    name:'सूर्यविनायक नगरपालिका'
  }
}

const FISCAL_YEAR_STRING = {
    '1': '2075/76',
    '2': '2076/77',
    '3': '2077/78',
    '4': '2078/79',
    '5': '2079/80',
    '6': '2080/81',
    '7': '2081/82',
    '8': '2082/83',
    '9': '2083/84',
    '10': '2084/85'
}

export default function ProductSection(props) {
  const classes = useStyles();
  const [budget_insights, setBudgetInsight] = React.useState(undefined);
  const [most_recent_fiscal_year, setMostRecentFiscalYear] = React.useState('');

  const getLatestYearBudget = (budgetData) => {
    const filterData = budgetData
    let remIndex = []
    filterData.forEach((item, i) => {
      filterData.forEach((item_another, j) => {
        if((item.administrative_unit === item_another.administrative_unit) && (i!==j)) {
          if(item.fiscal_year > item_another.fiscal_year) {
            remIndex.push(j)
          } else {
            remIndex.push(i)
          }
        }
      });
    });
    remIndex = [...new Set(remIndex)]
    remIndex.forEach((item) => {
      filterData.splice(item, 1);
    });
    return filterData
  }

  React.useEffect(() => {
    if (budget_insights === undefined) {
      fetch(API_BASE_URL + 'homepage/budgets/')
        .then(results => results.json())
        .then(data => {
          const budget_data = getLatestYearBudget(data.results);
          const fiscal_years = budget_data.map(budget_unit=>budget_unit.fiscal_year)
          setMostRecentFiscalYear(Math.max.apply(Math, fiscal_years))
          setBudgetInsight(budget_data);
        });
    }
  });

  let administrative_units = []
  let budgets_data_income = []
  let budgets_data_expense = []
  if (budget_insights && budget_insights.length > 0) {
    administrative_units = budget_insights.map((b,i)=>([title_map[b.administrative_unit].name ,' (आ. व. '+ FISCAL_YEAR_STRING[budget_insights[i].fiscal_year] + ')']))
    budgets_data_income = budget_insights.map(b=>b.total_estimated_income/10000000)
    budgets_data_expense = budget_insights.map(b=>b.total_estimated_expenditure/10000000)
  }

  return (
    <div className={classes.section}>
      <div style={{ color: '#333' }}>
      </div>
      <GridContainer>
        {!props.minute &&
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ color: "#134c7a", margin: '0'}}>
            <small>आ. व. <span style={{fontFamily: 'nepali-font', fontSize: '0.9rem'}}>{FISCAL_YEAR_STRING[most_recent_fiscal_year]}</span></small>
            <span><h3 className={classes.title} style={{ marginTop: '0px', color: '#134c7a'}}>अनुमानित बजेट</h3></span>
            <div style={{ width: '20px', borderBottom: "5px solid #134c7a", margin: 'auto' }}></div>
          </div>
        </GridItem>}
        <GridItem xs={12} sm={12} md={12} style={{ color: '#333', marginTop: props.minute && '-70px' }}>
          <ReactApexChart options={bar_options(administrative_units)} series={bar_series(budgets_data_income, budgets_data_expense)} type="bar" height={350} />
        </GridItem>
      </GridContainer>
      {!props.minute && <Button href="/budget" style={{ margin: 'auto', marginTop: '15px' }} color="primary">थप जानकारी</Button>}
    </div>
  );
}
